// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"560":"75603ebb","1793":"70c21f4f","2769":"b27c2b56","7713":"8d56f4f7","8134":"baa5c7a2","8512":"8d56f4f7","8525":"8d56f4f7"}[chunkId] + ".chunk.css";
};